import ReactGA from 'react-ga4';
import { TokenData } from '../slices/authSlice';

export const setUserProperties = (properties: object) => {
    ReactGA.gtag('set', 'user_properties', properties);
};

export const initializeGoogleAnalytics = (token: TokenData) => {
    if (!process.env.REACT_APP_GA_TRACKING_ID) {
        return;
    }

    setUserProperties({
        roles: token.roles
    });

    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
};